const isLocal = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
export const serverDomain = isLocal 
  ? "http://localhost:8443" 
  : (typeof window !== "undefined" ? `${window.location.protocol}//${window.location.hostname}/api` : "https://vedas-dev.transforma.in/api");